import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useAuth, formatApiError } from "../AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    referral_code: search.get("ref") || "",
  });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setSubmitting(true);
    try {
      await register(form);
      navigate("/app", { replace: true });
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-[#0a0a0a]" data-testid="member-register-page">
      <div className="w-full max-w-md bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-8 shadow-2xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-light text-[#C97654] mb-2">Join Passion Pilates</h1>
          <p className="text-[#E8DCC4]/60 text-sm">Create your account in seconds</p>
        </div>

        {error && (
          <div data-testid="register-error" className="mb-4 bg-[#8B2635]/20 border border-[#8B2635] rounded-lg px-4 py-3 text-[#FFB89A] text-sm">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <Input label="Full Name" value={form.name} onChange={update("name")} required testid="register-name-input" placeholder="Jane Doe" />
          <Input label="Email" type="email" value={form.email} onChange={update("email")} required testid="register-email-input" placeholder="your@email.com" autoComplete="email" />
          <Input label="Phone (optional)" value={form.phone} onChange={update("phone")} testid="register-phone-input" placeholder="0400 000 000" />
          <Input label="Password" type="password" value={form.password} onChange={update("password")} required testid="register-password-input" placeholder="Minimum 8 characters" autoComplete="new-password" />
          {form.referral_code && (
            <div className="bg-[#C97654]/10 border border-[#C97654]/40 rounded-lg px-4 py-2 text-sm">
              <span className="text-[#E8DCC4]/70">Referred by:</span>{" "}
              <span className="text-[#C97654] font-bold tracking-wider">{form.referral_code}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="register-submit-btn"
            className="w-full bg-gradient-to-r from-[#C97654] to-[#FF9472] hover:from-[#FF9472] hover:to-[#FFB89A] text-white py-3 rounded-lg font-bold transition-all duration-300 shadow-md disabled:opacity-50 mt-2"
          >
            {submitting ? "Creating account…" : "Create Account"}
          </button>
        </form>

        <div className="mt-6 text-center text-sm">
          <span className="text-[#E8DCC4]/60">Already a member?</span>{" "}
          <Link to="/app/login" data-testid="register-link-login" className="text-[#C97654] hover:text-[#FF9472] transition-colors font-medium">
            Sign in →
          </Link>
        </div>
      </div>
    </div>
  );
}

function Input({ label, testid, type = "text", ...rest }) {
  return (
    <div>
      <label className="block text-[#E8DCC4]/80 text-sm mb-2 font-medium">{label}</label>
      <input
        type={type}
        data-testid={testid}
        className="w-full bg-[#0a0a0a] border-2 border-[#2a2a2a] focus:border-[#C97654] rounded-lg px-4 py-3 text-[#E8DCC4] placeholder-[#E8DCC4]/30 transition-colors outline-none"
        {...rest}
      />
    </div>
  );
}
